// src/pages/SeleniumXPathGuide.js
import React, { useState } from 'react';
import { Container, Row, Col, Card, ListGroup, Badge, Button, Modal, Form, Alert, CloseButton } from 'react-bootstrap';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import TesterBudNavbar from '../../subComponent/TesterBudNavBar';
import { Link } from 'react-router-dom';

import HeroImage from '../icons/software-program-icon.png';

const SeleniumXPathGuide = () => {
    const [showPractice, setShowPractice] = useState(false);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [selectedOption, setSelectedOption] = useState('');
    const [customXpath, setCustomXpath] = useState('');
    const [feedback, setFeedback] = useState('');
    const [correctCount, setCorrectCount] = useState(0);
    const [incorrectCount, setIncorrectCount] = useState(0);
    const [showResult, setShowResult] = useState(false);

    const xpathQuestions = [
        {
            elementLabel: 'Text Field (Input Box)',
            htmlElement: `<input type="text" id="textField" />`,
            correctXpath: `//input[@id='textField']`,
            options: [
                `//input[@id='textField']`,
                `//div[@id='textField']`,
                `//input[@type='text']`,
                `//text()`
            ]
        },
        {
            elementLabel: 'Text Area',
            htmlElement: `<textarea id="textArea"></textarea>`,
            correctXpath: `//textarea[@id='textArea']`,
            options: [
                `//textarea[@id='textArea']`,
                `//input[@type='textarea']`,
                `//div[@id='textArea']`,
                `//text()`
            ]
        },
        {
            elementLabel: 'Click Me Button',
            htmlElement: `<button id="clickMeBtn">Click Me</button>`,
            correctXpath: `//button[@id='clickMeBtn']`,
            options: [
                `//button[@id='clickMeBtn']`,
                `//div[text()='Click Me']`,
                `//button[text()='Click']`,
                `//a[@id='clickMeBtn']`
            ]
        },
        {
            elementLabel: 'Single Checkbox',
            htmlElement: `<input type="checkbox" id="singleCheckbox" />`,
            correctXpath: `//input[@id='singleCheckbox']`,
            options: [
                `//input[@id='singleCheckbox']`,
                `//checkbox[@id='singleCheckbox']`,
                `//input[@type='checkbox']`,
                `//label[@for='singleCheckbox']`
            ]
        },
        {
            elementLabel: 'Option 1 Checkbox',
            htmlElement: `<div><input type="checkbox" name="option1" /> Option 1</div>`,
            correctXpath: `//input[@name='option1']`,
            options: [
                `//input[@name='option1']`,
                `//div[text()='Option 1']/input`,
                `//input[@value='option1']`,
                `//checkbox[text()='Option 1']`
            ]
        },
        {
            elementLabel: 'Radio Button 1',
            htmlElement: `<div><input type="radio" name="radioGroup" value="Radio 1" /> Radio 1</div>`,
            correctXpath: `//input[@name='radioGroup' and @value='Radio 1']`,
            options: [
                `//input[@name='radioGroup' and @value='Radio 1']`,
                `//input[@value='Radio 1']`,
                `//radio[@value='Radio 1']`,
                `//div[text()='Radio 1']/input`
            ]
        },
        {
            elementLabel: 'USA in Dropdown',
            htmlElement: `<select id="country"><option value="">Select a country</option><option value="USA">USA</option></select>`,
            correctXpath: `//select[@id='country']/option[@value='USA']`,
            options: [
                `//select[@id='country']/option[@value='USA']`,
                `//option[text()='USA']`,
                `//select/option[1]`,
                `//div[text()='USA']`
            ]
        },
        {
            elementLabel: 'Option B in Multi-Select',
            htmlElement: `<select multiple><option value="Option A">Option A</option><option value="Option B">Option B</option></select>`,
            correctXpath: `//select/option[@value='Option B']`,
            options: [
                `//select/option[@value='Option B']`,
                `//option[text()='Option B']`,
                `//select/option[2]`,
                `//div[text()='Option B']`
            ]
        },
        {
            elementLabel: 'Click Me Link',
            htmlElement: `<a href="#" id="clickMeLink">Click Me</a>`,
            correctXpath: `//a[@id='clickMeLink']`,
            options: [
                `//a[@id='clickMeLink']`,
                `//link[text()='Click Me']`,
                `//a[text()='Click']`,
                `//button[@id='clickMeLink']`
            ]
        },
        {
            elementLabel: 'Placeholder Image',
            htmlElement: `<img src="logo.png" alt="Placeholder" />`,
            correctXpath: `//img[@alt='Placeholder']`,
            options: [
                `//img[@alt='Placeholder']`,
                `//image[@src='logo.png']`,
                `//div/img`,
                `//img[text()='Placeholder']`
            ]
        },
        {
            elementLabel: 'Name Column Header in Table',
            htmlElement: `<table><thead><tr><th>ID</th><th>Name</th><th>Age</th></tr></thead><tbody><tr><td>1</td><td>Zui</td><td>30</td></tr></tbody></table>`,
            correctXpath: `//table/thead/tr/th[text()='Name']`,
            options: [
                `//table/thead/tr/th[text()='Name']`,
                `//th[2]`,
                `//table/th[2]`,
                `//td[text()='Name']`
            ]
        },
        {
            elementLabel: 'Hover Me Tooltip',
            htmlElement: `<div title="This is a tooltip!">Hover Me</div>`,
            correctXpath: `//div[@title='This is a tooltip!']`,
            options: [
                `//div[@title='This is a tooltip!']`,
                `//span[text()='Hover Me']`,
                `//div[text()='Hover']`,
                `//tooltip[text()='This is a tooltip!']`
            ]
        },
        {
            elementLabel: 'Slider Input',
            htmlElement: `<input type="range" id="slider" />`,
            correctXpath: `//input[@id='slider' and @type='range']`,
            options: [
                `//input[@id='slider' and @type='range']`,
                `//input[@type='range']`,
                `//div[@id='slider']`,
                `//slider[@id='slider']`
            ]
        },
        {
            elementLabel: 'Progress Bar Div',
            htmlElement: `<div class="progressBar"><div class="progressBarFill" style="width: 30%;"></div></div>`,
            correctXpath: `//div[@class='progressBar']/div[@class='progressBarFill']`,
            options: [
                `//div[@class='progressBar']/div[@class='progressBarFill']`,
                `//div[@class='progressBarFill']`,
                `//div[@class='progressBar']/div`,
                `//div[contains(@class, 'progressBarFill')]`
            ]
        },
        {
            elementLabel: 'Modal Content Paragraph',
            htmlElement: `<div id="modal"><p>This is a modal!</p><button>Close</button></div>`,
            correctXpath: `//div[@id='modal']/p`,
            options: [
                `//div[@id='modal']/p`,
                `//p[text()='This is a modal!']`,
                `//modal/p`,
                `//div/p`
            ]
        },
        {
            elementLabel: 'Date Input Field',
            htmlElement: `<input type="text" placeholder="YYYY-MM-DD" />`,
            correctXpath: `//input[@placeholder='YYYY-MM-DD']`,
            options: [
                `//input[@placeholder='YYYY-MM-DD']`,
                `//input[@type='date']`,
                `//input`,
                `//div[@placeholder='YYYY-MM-DD']`
            ]
        },
        {
            elementLabel: 'File Upload Input',
            htmlElement: `<input type="file" />`,
            correctXpath: `//input[@type='file']`,
            options: [
                `//input[@type='file']`,
                `//input`,
                `//file`,
                `//button[text()='Upload']`
            ]
        },
        {
            elementLabel: 'Drag Me Div',
            htmlElement: `<div id="draggable">Drag Me</div>`,
            correctXpath: `//div[@id='draggable']`,
            options: [
                `//div[@id='draggable']`,
                `//span[text()='Drag Me']`,
                `//div[text()='Drag']`,
                `//draggable`
            ]
        },
        {
            elementLabel: 'Iframe Element (e.g., body)',
            htmlElement: `<iframe id="myIframe" src="about:blank"></iframe>`,
            correctXpath: `//iframe[@id='myIframe']`,
            options: [
                `//iframe[@id='myIframe']`,
                `//frame[@id='myIframe']`,
                `//div[@id='myIframe']`,
                `//iframe`
            ]
        },
        {
            elementLabel: 'Dynamic Content Span',
            htmlElement: `<span id="dynamicText">Initial Content</span>`,
            correctXpath: `//span[@id='dynamicText']`,
            options: [
                `//span[@id='dynamicText']`,
                `//div[@id='dynamicText']`,
                `//span[text()='Initial Content']`,
                `//text()[contains(.,'Content')]`
            ]
        },
        {
            elementLabel: 'Notification Close Button',
            htmlElement: `<div class="notification"><button class="close">X</button></div>`,
            correctXpath: `//div[@class='notification']/button[@class='close']`,
            options: [
                `//div[@class='notification']/button[@class='close']`,
                `//button[@class='close']`,
                `//div/button`,
                `//span[text()='X']`
            ]
        },
        {
            elementLabel: 'Tab 2 Button',
            htmlElement: `<div class="tabs"><button id="tab1-btn" class="active">Tab 1</button><button id="tab2-btn">Tab 2</button></div>`,
            correctXpath: `//div[@class='tabs']/button[@id='tab2-btn']`,
            options: [
                `//div[@class='tabs']/button[@id='tab2-btn']`,
                `//button[@id='tab2-btn']`,
                `//button[text()='Tab 2']`,
                `//div/button[2]`
            ]
        },
        {
            elementLabel: 'Accordion Item 1 Header',
            htmlElement: `<div class="accordion"><div class="item"><div class="header">Item 1</div><div class="content">Content 1</div></div></div>`,
            correctXpath: `//div[@class='accordion']/div[@class='item'][1]/div[@class='header']`,
            options: [
                `//div[@class='accordion']/div[@class='item'][1]/div[@class='header']`,
                `//div[@class='header'][text()='Item 1']`,
                `//div[@class='item']/div[1]`,
                `//h3[text()='Item 1']`
            ]
        },
        {
            elementLabel: 'Item 5 in Virtual Scroll',
            htmlElement: `<div class="virtualScroll"><div class="item">Item 1</div><div class="item">Item 5</div></div>`,
            correctXpath: `//div[@class='virtualScroll']/div[text()='Item 5']`,
            options: [
                `//div[@class='virtualScroll']/div[text()='Item 5']`,
                `//div[@class='item'][5]`,
                `//div[contains(@class, 'item') and text()='Item 5']`,
                `//li[text()='Item 5']`
            ]
        },
    ];

    const current = xpathQuestions[currentQuestion];

    const handleCheck = () => {
        if (selectedOption === current.correctXpath || customXpath === current.correctXpath) {
            setFeedback('✅ Correct XPath!');
            setCorrectCount(prev => prev + 1);
        } else {
            setFeedback('❌ Incorrect. Try Again!');
            setIncorrectCount(prev => prev + 1);
        }
    };

    const handleNext = () => {
        setSelectedOption('');
        setCustomXpath('');
        setFeedback('');
        setCurrentQuestion((prev) => (prev + 1) % xpathQuestions.length);
    };

    const handleFinishPractice = () => {
        setShowPractice(false);
        setShowResult(true);
    };

    const handleStartPractice = () => {
        setShowPractice(true);
        setCurrentQuestion(0);
        setSelectedOption('');
        setCustomXpath('');
        setFeedback('');
        setCorrectCount(0);
        setIncorrectCount(0);
        setShowResult(false);
    };

    return (
        <HelmetProvider>
            <Helmet>
                <title>Selenium XPath Guide: Mastering Web Element Location</title>
                <meta name="description" content="Learn how to use XPath in Selenium for locating web elements. Covers absolute and relative XPaths, using text and attributes, logical operators, and more." />
                {/* Add more SEO meta tags as needed */}
            </Helmet>
            <Container fluid className="hero-section bg-primary text-white py-5" style={{ position: 'relative', overflow: 'hidden' }}>
          <Row className="align-items-center justify-content-center">
            <Col md={6} className="text-center text-md-start">

              <h3 className="display-4 fw-bold mb-3">TesterBud – The Ultimate Automation Playground</h3>
              <p className="lead mb-2">
                TesterBud – The Ultimate Playground for Automation Testers! 🚀 Practice XPath, UI automation, and real-world testing challenges with interactive dummy sites.
              </p>
              <Button
                as={Link}
                to="/practice-page-selection"
                variant="warning"
                size="md"
                className="fw-bold text-dark border-0 shadow-sm"
                style={{
                  padding: "24px 36px",
                  borderRadius: "20px",
                  transition: "all 0.3s ease-in-out"
                }}
              >
                Get Started ➜
              </Button>

            </Col>
            <Col md={5} className="d-none d-md-block text-center">
              {/* Replace with your actual hero image component or import */}
              <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                <div
                  style={{
                    width: '60%', // Adjust the size of the circular area
                    height: '60%', // Ensure width and height are equal for a perfect circle
                    borderRadius: '70%', // This creates the circular shape
                    overflow: 'auto', // Clips the image to the circle
                    marginTop: '-4%',
                    marginRight: '10%',
                    marginBottom: '-4%',
                  }}
                >
                  <img src={HeroImage} alt="Automation Illustration" className="img-fluid" style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain', // Or 'cover' depending on desired behavior
                  }} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <TesterBudNavbar />
            <Container className="mt-5 pt-4 pb-5">
                <Row>
                    <Col md={{ span: 10, offset: 1 }}>
                        <Card className="shadow-lg rounded-lg">
                            <Card.Body className="p-5">
                                <h1 className="text-primary mb-4">Selenium XPath Guide: Mastering Web Element Location</h1>

                                <section className="mb-4">
                                    <h2 className="text-secondary mb-3">What is XPath?</h2>
                                    <p>
                                        XPath (XML Path Language) is a query language used for selecting nodes from an XML or HTML document. In the context of Selenium, XPath is a powerful locator strategy to find and interact with web elements on a page. It allows you to navigate through the HTML structure of a webpage.
                                    </p>
                                    {!showPractice && (
                                        <div className="text-center mt-4">
                                            <Button variant="success" size="lg" onClick={handleStartPractice}>
                                                Practice XPath 🔍
                                            </Button>
                                        </div>
                                    )}
                                </section>

                                <section className="mb-4">
                                    <h2 className="text-secondary mb-3">Types of XPath</h2>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item>
                                            <strong>1. Absolute XPath:</strong> Starts from the root of the HTML document (the `html` tag) and provides a direct path to the element. It begins with a single forward slash (`/`).
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>/html/body/div[1]/form/input[1]</code>
                                    {/* ... Types of XPath content ... */}
                                            </pre>
                                            <p className="mt-2 text-muted">
                                                While precise, absolute XPaths are fragile. Any change in the HTML structure can break them.
                                            </p>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>2. Relative XPath:</strong> Starts from any node in the HTML document and uses double forward slashes (`//`) to select elements. It's more flexible and less prone to breakage due to minor UI changes.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//input[@id='username']`}</code>
                                            </pre>
                                            <p className="mt-2 text-muted">
                                                Relative XPaths are generally preferred for robust automation scripts.
                                            </p>
                                        </ListGroup.Item>
                                    </ListGroup>
                                    {!showPractice && (
                                        <div className="text-center mt-4">
                                            <Button variant="success" size="lg" onClick={handleStartPractice}>
                                                Practice XPath 🔍
                                            </Button>
                                        </div>
                                    )}
                                </section>

                                <section className="mb-4">
                                    <h2 className="text-secondary mb-3">Getting XPath Using Attributes</h2>
                                    <p>You can locate elements based on their attributes using the `@` symbol followed by the attribute name and its value.</p>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item>
                                            <strong>Using `id` attribute:</strong>
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//input[@id='login-button']`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>Using `name` attribute:</strong>
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//input[@name='password']`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>Using `class` attribute:</strong>
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//button[@class='btn btn-primary']`}</code>
                                            </pre>
                                            <p className="mt-2 text-muted">
                                                Note: If the `class` attribute has multiple values, you might need to use functions like `contains()`.
                                            </p>
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//button[contains(@class, 'primary')]`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>Using other attributes (e.g., `type`, `href`):</strong>
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//input[@type='checkbox']`}</code>
                                                <code>{`//a[@href='/home']`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                    </ListGroup>
                                </section>
                                <section className="mb-4">
                                    <h2 className="text-secondary mb-3">Getting XPath Using Text</h2>
                                    <p>You can locate elements based on the visible text they contain using the `text()` function.</p>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item>
                                            <strong>Using exact text:</strong>
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//button[text()='Submit']`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>Using partial text with `contains()`:</strong>
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//a[contains(text(), 'Forgot')]`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                    </ListGroup>
                                </section>
                                <section className="mb-4">
                                    <h2 className="text-secondary mb-3">Using Logical Operators</h2>
                                    <p>You can combine multiple conditions using logical operators like `and` and `or`.</p>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item>
                                            <strong>Using `and`:</strong> Selects elements that satisfy both conditions.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//input[@type='text' and @name='username']`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>Using `or`:</strong> Selects elements that satisfy either of the conditions.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//button[@id='login' or text()='Sign In']`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                    </ListGroup>
                                </section>
                                <section className="mb-4">
                                    <h2 className="text-secondary mb-3">XPath Axes</h2>
                                    <p>XPath axes are methods used to select nodes relative to the current node.</p>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item>
                                            <strong>`ancestor`:</strong> Selects all ancestors (parent, grandparent, etc.) of the current node.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//input[@id='username']/ancestor::form`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>`child`:</strong> Selects all children of the current node.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//div[@class='container']/child::p`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>`parent`:</strong> Selects the parent of the current node.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//input[@id='password']/parent::div`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>`following-sibling`:</strong> Selects all siblings after the current node.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//input[@id='email']/following-sibling::input`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>`preceding-sibling`:</strong> Selects all siblings before the current node.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//button[@id='submit']/preceding-sibling::input`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        {/* Add more axes as needed: descendant, following, preceding, etc. */}
                                    </ListGroup>
                                </section>
                                <section className="mb-4">
                                    <h2 className="text-secondary mb-3">Functions in XPath</h2>
                                    <p>XPath provides various built-in functions that can be used to refine your element location strategies.</p>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item>
                                            <strong>`contains(string1, string2)`:</strong> Returns true if `string1` contains `string2`. (Used with text and attributes)
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//a[contains(@href, 'product')]`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>`text()`:</strong> Selects the text content of a node.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//h1[text()='Welcome']`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>`starts-with(string1, string2)`:</strong> Returns true if `string1` starts with `string2`.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//input[starts-with(@id, 'user')]`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>`ends-with(string1, string2)`:</strong> Returns true if `string1` ends with `string2`.
                                            <pre className="bg-light p-2 rounded mt-2">
                                                <code>{`//input[ends-with(@id, 'name')]`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                        <ListGroup.Item>
                                            <strong>`string-length(string)`:</strong> Returns the length of the string.
                                            <pre className="bg-light p-2 rounded mt-2">
                                            <code>{`//input[@name and string-length(@name) > 5]`}</code>
                                            </pre>
                                        </ListGroup.Item>
                                {/* ... other sections about XPath concepts ... */}
                                        {/* Add more functions as needed */}
                                    </ListGroup>
                                </section>
                                <section className="mb-4">
                                    <h2 className="text-secondary mb-3">Tips for Writing Effective XPaths</h2>
                                    <ListGroup variant="flush">
                                        <ListGroup.Item><Badge pill bg="info" className="mr-2">Tip</Badge>Prefer relative XPaths over absolute XPaths for better stability.</ListGroup.Item>
                                        <ListGroup.Item><Badge pill bg="info" className="mr-2">Tip</Badge>Use unique attributes like `id` or `name` whenever possible.</ListGroup.Item>
                                        <ListGroup.Item><Badge pill bg="info" className="mr-2">Tip</Badge>Combine attributes and text for more specific locators.</ListGroup.Item>
                                        <ListGroup.Item><Badge pill bg="info" className="mr-2">Tip</Badge>Use browser developer tools (e.g., Inspect Element in Chrome/Firefox) to inspect the HTML structure and test your XPaths.</ListGroup.Item>
                                        <ListGroup.Item><Badge pill bg="info" className="mr-2">Tip</Badge>Be mindful of dynamic attributes or text that might change frequently.</ListGroup.Item>
                                        <ListGroup.Item><Badge pill bg="info" className="mr-2">Tip</Badge>Keep your XPaths as simple and readable as possible.</ListGroup.Item>
                                    </ListGroup>
                                </section>

                                <section className="text-center mt-5">
                                    <p className="text-muted">
                                        Practice writing different types of XPaths on various web pages to solidify your understanding.
                                    </p>
                                    {!showPractice && (
                                        <Button variant="success" size="lg" onClick={handleStartPractice}>
                                            Practice XPath Now 🚀
                                        </Button>
                                    )}
                                </section>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {showPractice && (
                    <div className="position-fixed top-50 start-50 translate-middle w-75 z-3 bg-white rounded shadow p-4 border border-dark">
                        <div className="d-flex justify-content-between align-items-start mb-3">
                            <h4>XPath Practice</h4>
                            <Badge pill bg="info" className="ms-2">
                                {currentQuestion + 1}/{xpathQuestions.length}
                            </Badge>
                            <CloseButton onClick={() => setShowPractice(false)} />
                        </div>

                        <Card className="p-4 border-0">
                            <h5>Element to locate: <strong>{current.elementLabel}</strong></h5>

                            <div className="bg-light p-3 my-3 rounded" dangerouslySetInnerHTML={{ __html: current.htmlElement }} />

                            <Form>
                                <Form.Label>Select the correct XPath:</Form.Label>
                                {current.options.map((opt, idx) => (
                                    <Form.Check key={idx}
                                        type="radio"
                                        label={<code>{opt}</code>}
                                        value={opt}
                                        checked={selectedOption === opt}
                                        onChange={() => setSelectedOption(opt)}
                                    />
                                ))}

                                <Form.Group className="mt-4">
                                    <Form.Label>Or Write your XPath manually:</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        placeholder="Type your custom XPath..."
                                        value={customXpath}
                                        onChange={(e) => setCustomXpath(e.target.value)}
                                    />
                                </Form.Group>

                                {feedback && (
                                    <Alert variant={feedback.startsWith('✅') ? 'success' : 'danger'} className="mt-3">
                                        {feedback} {feedback.startsWith('✅') ? `(+1 correct)` : `(+1 wrong)`}
                                    </Alert>
                                )}

                                <div className="d-flex justify-content-between mt-4">
                                    <Button variant="primary" onClick={handleCheck}>
                                        Check Answer
                                    </Button>
                                    <Button variant="secondary" onClick={handleNext} disabled={currentQuestion === xpathQuestions.length - 1}>
                                        Next Element ➡️
                                    </Button>
                                    <Button variant="danger" onClick={handleFinishPractice}>
                                        Finish 🏁
                                    </Button>
                                </div>
                            </Form>

                            <div className="mt-4">
                                <Alert variant="success">Correct: {correctCount}</Alert>
                                <Alert variant="danger">Incorrect: {incorrectCount}</Alert>
                            </div>
                        </Card>
                    </div>
                )}

                <Modal show={showResult} onHide={() => setShowResult(false)} centered>
                    <Modal.Header closeButton className="bg-dark text-white">
                        <Modal.Title>🎯 Your Result Summary</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="bg-light">
                        <div className="text-center">
                            <h5>Total Attempted: <Badge bg="secondary">{correctCount + incorrectCount}</Badge></h5>
                            <h5 className="mt-3 text-success">✅ Correct: <Badge bg="success">{correctCount}</Badge></h5>
                            <h5 className="mt-2 text-danger">❌ Incorrect: <Badge bg="danger">{incorrectCount}</Badge></h5>
                            <hr />
                            <p className="text-muted">Keep practicing to master XPath!</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="bg-light">
                        <Button variant="dark" onClick={() => setShowResult(false)}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        </HelmetProvider>
    );
};

export default SeleniumXPathGuide;